import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export default styled.div`
  grid-area: ${({ area }) => area};
  font-weight: 500;

  ${upTo('sm')`
    display: ${({ hidesmall }) => (hidesmall ? 'none' : 'block')};
    margin-top: 1rem;
    
    &:first-child {
      margin-top: 0;
    }
  `}
`;
